


















































































































































































































































import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator'
import { Action, Getter, Mutation } from 'vuex-class';
import {
  FormRowWings,
  SelectWings,
  TemplateInputWings,
  FieldTooltip,
  InputWings,
  TextareaWings,
  SmsTextInputWings
} from 'wings-ui-components';
import GenericTemplate from '@/pages/Pages/Templates/GenericTemplate.vue';
import { MsgTransports } from '@/store/types';
import { PushTemplateItemImpl } from '@/store/templates/types';
import {cloneDeep, unionBy} from "lodash";
import {notifyError} from '@/utils/notify-helper';
import CascadingOptions from '@/components/Others/CascadingOptions.vue';

Component.registerHooks(['beforeRouteLeave']);

@Component({components: {
    FieldTooltip,
    GenericTemplate,
    FormRowWings,
    SelectWings,
    InputWings,
    TextareaWings,
    SmsTextInputWings,
    CascadingOptions
}})
export default class PushTemplate extends Vue {
  @Ref('genericTemplate') genericTemplate: any;
  @Prop({default: null}) distribution: any;

  @Getter("templateObject") template: any;
  @Mutation('setTemplateObject') setTemplateObject: any

  @Getter("pushApplications") applicationsList: any;
  // @Getter("applicationAttributes") applicationAttributesList: any;
  @Getter("deliveryType") deliveryTypeList: any;
  @Getter("pushGroupApplications") groupApplicationsList: any;

  @Action("getPushApplications") actionGetApplications: any;
  // @Action("getApplicationAttributes") actionGetApplicationAttributes: any;
  @Action("getPushGroupApplications") actionGetGroupsApplications: any;

  private transport: MsgTransports = MsgTransports.PUSH;
  private templateObject: PushTemplateItemImpl = new PushTemplateItemImpl();
  activeApplication: string = 'application';
  applicationsValue = '';
  appGroups: {id: number; name: string}[] = [];
  applications: {id: number; name: string}[] = [];

  created() {
    this.setTemplate();
    try {
      this.actionGetApplications();
      this.actionGetGroupsApplications();
    } catch(error) {
      notifyError(error);
    }
  }

  @Watch('$route.params.id', {immediate: true})
  onRouteIdChange(val: string, oldVal?: string) {
    if (val) {
      this.setTemplate()
    }
  }

  setTemplate() {
    this.setTemplateObject(cloneDeep(this.templateObject))
  }

  onLoadTemplate(template: any) {
    if (!template.applications?.length) this.activeApplication = 'appGroups';
    this.applications = template.applications || [];
    this.genericTemplate.template.applicationsIds = this.applications.map(app => app.id);
    this.appGroups = template.appGroups || [];
    this.genericTemplate.template.appGroupsIds = this.appGroups.map(app => app.id);
    this.$emit('onLoadTemplate', template)
  }

  onAddApplication(id: number) {
    if (this.genericTemplate.template.applicationsIds?.includes(id) || id == null) return;
    const option = this.applicationsList.find((item: any) => item.applicationId == id);
    if (!option) return;
    this.applications.push({id: option.applicationId, name: option.appName});
    this.genericTemplate.template.applicationsIds?.push(id);
  }

  onDeleteApplication(application: any) {
    const idx = this.applications.findIndex((item: any) => item.id == application.id);
    if (idx !== -1) {
      this.applications.splice(idx, 1);
      this.genericTemplate.template.applicationsIds?.splice(idx, 1);
    }
  }

  onAddAppGroup(id: number) {
    if (this.genericTemplate.template.appGroupsIds?.includes(id) || id == null) return;
    const option = this.groupApplicationsList.find((item: any) => item.id == id);
    if (!option) return;
    this.appGroups.push(option);
    this.genericTemplate.template.appGroupsIds?.push(id);
  }

  onDeleteAppGroup(appGroup: any) {
    const idx = this.appGroups.findIndex((item: any) => item.id == appGroup.id);
    if (idx !== -1) {
      this.appGroups.splice(idx, 1);
      this.genericTemplate.template.appGroupsIds?.splice(idx, 1);
    }
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    this.genericTemplate.beforeLeave(to,from,next)
  }

  @Watch('activeApplication', { immediate: false })
  onChangeActiveApplication(newVal: string) {
    this.applicationsValue = '';
    if (newVal === 'application') {
      this.appGroups = [];
      this.genericTemplate.template.appGroups = [];
      this.genericTemplate.template.appGroupsIds = [];
      this.genericTemplate.template.groupSelectionRule = undefined;
      this.genericTemplate.template.appSelectionRule = undefined;
    } else {
      this.applications = [];
      this.genericTemplate.template.applications = [];
      this.genericTemplate.template.applicationsIds = [];
      this.genericTemplate.template.appByDate = undefined;
      this.genericTemplate.template.appSelectionRule = this.genericTemplate.template.appSelectionRule || 1;
    }
  }

  @Watch('applications', { immediate: false })
  onChangeApplications(newVal: string) {
    if(newVal.length >= 2) {
      this.genericTemplate.template.appByDate = this.genericTemplate.template.appByDate || 1;
    } else {
      this.genericTemplate.template.appByDate = undefined;
    }
  }

  @Watch('appGroups', { immediate: false })
  onChangeAppGroups(newVal: string) {
    if(newVal.length >= 2) {
      this.genericTemplate.template.groupSelectionRule = this.genericTemplate.template.groupSelectionRule || 1;
    } else {
      this.genericTemplate.template.groupSelectionRule = undefined;
    }
  }

  // async onTemplateChangePartner(partner:PartnerItem) {
  //   const appId: number = this.genericTemplate?.template.applicationId;
  //   this.genericTemplate.template.applicationId = null;
  //   if (partner){
  //     await this.actionGetApplications({partner:partner.name});
  //     if (this.applicationsList.some((app: PushApplicationItem) => app.id === appId))
  //       this.genericTemplate.template.applicationId = appId;
  //   }
  // }

  // onChangeApplicationId() {
  //   if (this.genericTemplate.template.applicationId) {
  //     try {
  //       this.actionGetApplicationAttributes({applicationId: this.genericTemplate.template.applicationId})
  //     } catch(error) {
  //       notifyError(error);
  //     }
  //   }
  // }
}
